import {
  FLIGHTS_SHOP_DEPARTURE_PATH,
  FLIGHTS_SHOP_MULTICITY_PATH,
  FLIGHTS_SHOP_REVIEW_FARE_PATH,
  FLIGHTS_SHOP_REVIEW_PATH,
} from "@b2bportal/core-utilities";
import { TripCategory } from "@overrides/types";

const FLIGHT_REVIEW_PATHS = [
  FLIGHTS_SHOP_REVIEW_PATH,
  FLIGHTS_SHOP_REVIEW_FARE_PATH,
];

/**
 * The flight review page can't be rebuilt from the Redux state restored after a
 * language change reload (flight shop data is only partially persisted), so it
 * renders blank. Send the user back to the first flight shop step instead; the
 * search query params are shared between shop steps so the search is kept.
 *
 * Returns the path to reload into, or undefined to stay on the current page.
 */
export const getLanguageChangeRedirectPath = (
  pathname: string,
  tripCategory: TripCategory
): string | undefined => {
  const normalizedPathname = pathname.replace(/\/+$/, "");
  if (!FLIGHT_REVIEW_PATHS.includes(normalizedPathname)) {
    return undefined;
  }

  return tripCategory === TripCategory.MULTI_CITY
    ? FLIGHTS_SHOP_MULTICITY_PATH(0)
    : FLIGHTS_SHOP_DEPARTURE_PATH;
};
